import { NgModule } from '@angular/core';

import { ProdutosDetalheComponent } from './produtos-detalhe.component';
import { ZoomImageComponent } from './zoom-image/zoom-image.component';
import { CropImagesComponent } from './crop-images/crop-images.component';
import { AtributosComponent } from './atributos/atributos.component';
import { ProdutoRoutingModule } from './produto-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { SafePipe } from "../../shared/pipes/safe.pipe";


@NgModule({
    declarations: [
        ZoomImageComponent,
        CropImagesComponent,
        AtributosComponent,
        ProdutosDetalheComponent
    ],
    imports: [
        ProdutoRoutingModule,
        SharedModule,
        SafePipe
    ]
})
export class ProdutoModule { }
